import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import { CreateAcquisitionForm } from "../Forms";
import { Acquisition } from "@/types";

interface CopyAcquisitionModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  copyFromData?: Acquisition;
  caseInfo?: { case_id: number };
  evidenceInfo?: { evidence_id: number; case_id?: number };
}

export const CopyAcquisitionModal: FC<CopyAcquisitionModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  copyFromData,
  caseInfo,
  evidenceInfo,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <CreateAcquisitionForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        copyFromData={copyFromData}
        caseInfo={caseInfo}
        evidenceInfo={evidenceInfo}
        width={600}
      />
    </Modal>
  );
};
